import React, { useEffect, useRef, useState } from 'react';
import { Button, Cards, Icon } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { Document, Page } from 'react-pdf';
import { getParameter, storeJWT } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
const pageSize = 20;

export const InvoicesViewPage = () => {
    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const { setLoading } = useGlobalState();
    const [initLoading, setInitLoading] = useState(true);
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const containerRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const sideNavRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      function updateWidth() {
        const sideNavWidth = sideNavRef.current?.clientWidth || 0;
        const availableWidth = window.innerWidth - sideNavWidth;
        console.log("sideNavWidth:", sideNavWidth)
        console.log("window.innerWidth:", window.innerWidth)
        console.log("sideNavRef.current?.clientWidth:", sideNavRef.current?.clientWidth)
        
        setContainerWidth(availableWidth > 0 ? availableWidth : 0);
      }
      updateWidth();
      window.addEventListener('resize', updateWidth);
      return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const id = getParameter(window.location.hash, 'id');

    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/invoices/get',
                    'JWT': JWT,
                },
                body: JSON.stringify({
                    idFacturacion: id,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                console.log(data.invoice);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (initLoading) {
            setTimeout(function(){
            handleRefresh();
            },500)
        }
        setInitLoading(false);
    }, []);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Facturación', href: '#invoices' },
                        { text: 'Emitidas', href: '#invoices/issued' },
                        { text: 'Visualizador', href: '#invoices/issued' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Button>{containerWidth}</Button> {/* Debug width */}
                    <div ref={containerRef} style={{ width: '100%', overflowX: 'auto' }}>
                        <Document
                            file="https://api.llavemovil.com/documents/33.00000965.pdf"
                            loading="Cargando PDF"
                        >
                            <Page
                                pageNumber={1}
                                width={containerWidth}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                            />
                        </Document>
                    </div>
                </>
            }
        />
    );
};
